import { Action, createReducer, on } from '@ngrx/store';
import { StateBuilder } from '../../../model/state.builder';
import { AddressActions } from './address.actions';
import { IAddressState } from './address.state';

export const initialAddressState: IAddressState = {
  model: undefined,
  data: undefined,
  uiState: undefined
};

const addressReducerFn = createReducer(
  initialAddressState,
  on(AddressActions.reset, (state: IAddressState, action) => {
    return new StateBuilder<IAddressState>(initialAddressState).build();
  }),
  on(AddressActions.updateModel, (state: IAddressState, action) => {
    return new StateBuilder<IAddressState>(state, action).build();
  }),
  on(AddressActions.load, (state: IAddressState, action) => {
    return new StateBuilder<IAddressState>(state).toLoading().build();
  }),
  on(AddressActions.loadSuccess, (state: IAddressState, action) => {
    return new StateBuilder<IAddressState>(state /*, action - there is no data in this action*/).toLoaded().build();
  }),
  on(AddressActions.submit, (state: IAddressState) => {
    return new StateBuilder<IAddressState>(state).toLoading().build();
  }),
  on(AddressActions.submitSuccess, (state: IAddressState, action) => {
    return {
      ...state,
      ...{
        model: {
          ...state.model,
          ...action.model
        }
      },
      ...{
        data: {
          ...state.data,
          ...action.data
        }
      }
    };

    // return new StateBuilder<IAddressState>(state, action).toLoaded().build();
  })
);

export function addressReducer(state: IAddressState | undefined, action: Action) {
  return addressReducerFn(state, action);
}
